exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, " .c-field-list__row + .c-field-list__row .o-form {\n  margin-top: 0;\n}\n\n.c-field-list__row {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.c-field-list__add {\n  margin-top: 1.5rem;\n}\n\n.c-field-list__remove {\n  margin-left: auto;\n  margin-bottom: -1.25rem;\n  padding: .25rem;\n  z-index: 1;\n}\n", ""]);

